export const services = [
    { partNumber: "S101-RV", taxService: "1.01" },
    { partNumber: "S102-RV", taxService: "1.02" },
    { partNumber: "S103-RV", taxService: "1.03" },
    { partNumber: "S104-RV", taxService: "1.04" },
    { partNumber: "S105-RV", taxService: "1.05" },
    { partNumber: "S106-RV", taxService: "1.06" },
    { partNumber: "S107-RV", taxService: "1.07" },
    { partNumber: "S802-RV", taxService: "8.02" },
    { partNumber: "S1001-RV", taxService: "10.01" },
    { partNumber: "S1002-RV", taxService: "10.02" },
    { partNumber: "S1003-RV", taxService: "10.03" },
    { partNumber: "S1004-RV", taxService: "10.04" },
    { partNumber: "S1005-RV", taxService: "10.05" },
    { partNumber: "S1008-RV", taxService: "10.08" },
    { partNumber: "S1009-RV", taxService: "10.09" },
    { partNumber: "S1010-RV", taxService: "10.10" },
    { partNumber: "S1213-RV", taxService: "12.13" },
    { partNumber: "S1304-RV", taxService: "13.04" },
    { partNumber: "S1401-RV", taxService: "14.01" },
    { partNumber: "S1402-RV", taxService: "14.02" },
    { partNumber: "S1406-RV", taxService: "14.06" },
    { partNumber: "S1701-RV", taxService: "17.01" },
    { partNumber: "S1702-RV", taxService: "17.02" },
    { partNumber: "S1703-RV", taxService: "17.03" },
    { partNumber: "S1706-RV", taxService: "17.06" },
    { partNumber: "S1722-RV", taxService: "17.22" },
    { partNumber: "S1724-RV", taxService: "17.24" },
    { partNumber: "S3101-RV", taxService: "31.01" },
    { partNumber: "S1005-RV - 06298", taxService: "06298" },
    { partNumber: "S1009-RV - 06009", taxService: "06009" }
]